/**
 * Get URL query parameter by name
 * @param {string} name - Parameter name to retrieve
 * @returns {string|null} Parameter value or null if not found
 */
export function getUrlParameter(name) {
	const urlParams = new URLSearchParams(window.location.search)
	return urlParams.get(name)
}

/**
 * Get all URL query parameters as an object
 * @returns {Object} Object containing all query parameters
 */
export function getAllUrlParameters() {
	const urlParams = new URLSearchParams(window.location.search)
	const params = {}

	for (const [key, value] of urlParams.entries()) {
		params[key] = value
	}

	return params
}
